/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface EditVariantModalDispatchParams {
    documentId: number;
    chapterId: number;
    sectionId: number;
    variantId: number;
    canEditDocument: boolean;
}

export interface EditVariantModalState {
    isOpen: boolean;

    data: EditVariantModalDispatchParams | null;
}

const initialState: EditVariantModalState = {
    isOpen: false,

    data: null,
};

export const editVariantModalSlice = createSlice({
    name: 'edit-variant-modal',
    initialState,
    reducers: {
        open(state: EditVariantModalState, action: PayloadAction<EditVariantModalDispatchParams>) {
            state.isOpen = true;
            state.data = action.payload;
        },
        close(state: EditVariantModalState) {
            state.isOpen = false;
            state.data = null;
        },
    },
}); 